export const listenRecordModalVisibleSelector = (state) =>
  state.callHistoryStore.listenRecordModalVisible;
export const currentRecordUrlSelector = (state) =>
  state.callHistoryStore.currentRecordUrl;
export const currentCallInfoSelector = (state) =>
  state.callHistoryStore.currentCallInfo;
